<template>
    <v-card v-if="spielerExport">
        <v-card-title class="pb-0">
            <v-icon class="mr-1">mdi-account-arrow-down</v-icon>Spieler Export
        </v-card-title>
        <v-card-text>
            <v-row no-gutters align="center">
                <v-col cols="12" class="subtitle-1 font-weight-bold">
                    <div v-if="spielerExport.level === 'verein'" class="mb-3">
                        Gewählter Verein: {{spielerExport.selectedVereinId}}
                    </div>
                    <div v-if="spielerExport.level === 'lv'">
                        Gewählter Landesverband: {{spielerExport.selectedVerbandId}}
                    </div>
                </v-col>
                <v-col cols="12" class="pr-1" v-if="spielerExport.level !== 'verein'">
                    <v-radio-group v-model="spielerExport.roleFilter" row :disabled="spielerExport.isExporting">
                        <v-radio label="alle Spieler" value=""/>
                        <v-radio label="nur Schiedsrichter" value="isSchiedsrichter"/>
                        <v-radio label="nur Trainer" value="isTrainer" v-if="spielerExport.level==='pass'"/>
                    </v-radio-group>
                </v-col>
                <v-col cols="12" md="5" v-if="spielerExport.level==='pass' && spielerExport.roleFilter!=='isTrainer'">
                    <v-autocomplete v-model="spielerExport.selectedVerbandId"
                                    :disabled="spielerExport.isExporting"
                                    :items="spielerExport.landesVerbaende" class="mb-5"
                                    label="Landesverband wählen" outlined dense item-text="text"
                                    item-value="id" clearable hide-details/>
                </v-col>
                <v-col cols="12">
                    <v-alert v-if="!spielerExport.isExporting" text color="warning" icon="mdi-alert">
                        Achtung: Oftmalige Spieler-Exporte an einem Tag können Kosten für den Verband verursachen!
                        Bitte vermeide unnötige Exporte!
                    </v-alert>
                    <v-alert v-else text icon="mdi-information">
                        Die gewünschten Daten werden exportiert, bitte um etwas Geduld!
                        <v-progress-linear indeterminate color="grey" class="mt-2"/>
                    </v-alert>
                </v-col>
                <v-col cols="12" class="text-right">
                    <v-btn color="primary" @click="exportToExcel()" :disabled="spielerExport.disableExport()">
                        <v-icon>mdi-download</v-icon>Excel Export</v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-snackbar v-model="showSnackbar" :color="spielerExport.spieler.length===0?'error':'success'">
            Es wurde(n) {{spielerExport.spieler.length}} Spieler
            exportiert <span v-if="spielerExport.spieler.length===0">(keine Spieler gefunden)</span>!
        </v-snackbar>
        <slot></slot>
    </v-card>
</template>

<script>
import {SpielerExport} from "@/services/data/spielerExport/spielerExport";

export default {
    name: "spieler-export-filter",
    props: ['level', 'lvId', 'vereinsId'],
    data: () => ({
        spielerExport: null,
        search: null,
        showSnackbar: false
    }),
    computed: {
        user(){ return this.$store.state.user }
    },
    created(){
        this.init()
    },
    methods: {
        init(){
            this.spielerExport = new SpielerExport(this.level, this.lvId, this.vereinsId, this.user)
        },
        exportToExcel(){
            this.spielerExport.exportToExcel()
        }
    },
    watch: {
        'spielerExport.roleFilter'(to){
            if ( to === 'isTrainer' ) this.spielerExport.selectedVerbandId = null
        },
        'spielerExport.isExporting'(to,from){
            if ( !to && from ) this.showSnackbar = true
        }
    }
}
</script>

<style scoped>
</style>